var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.forUpdate)?_c('CreateNewInvoice'):_vm._e(),(_vm.forUpdate)?_c('UpdateInvoice',{attrs:{"id":_vm.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }